import { styled } from '@stitches/react'
import { gray15 } from '../platform/color'

export const FieldLabel = styled('label', {
  fontSize: '12px',
  lineHeight: '20px',
  paddingBottom: '6px',
  fontWeight: 500,
  color: gray15
})
